import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { config } from 'config';

const datadogConfig = {
  clientToken: 'pubae6ddfb5e329731533b7db3d5b530610',
  site: 'datadoghq.com',
  service: 'services-nuvem-pago-new-admin-app',
  env: config.env,
  version: config.version,
  forwardErrorsToLogs: true,
  trackResources: true,
  trackLongTasks: true,
  useCrossSiteSessionCookie: true,
};

datadogRum.init({
  ...datadogConfig,
  allowedTracingUrls: [
    'https://services-financials-payments-commons.tiendanube.com',
    (url) => (config.api.bff ? url.startsWith(config.api.bff) : false),
  ],
  applicationId: 'f30daa6e-7b45-4a5b-ad6c-22e2d20c10c9',
  sessionSampleRate: 5,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  defaultPrivacyLevel: 'mask-user-input',
});

datadogLogs.init({
  ...datadogConfig,
  sessionSampleRate: 100,
});

datadogRum.startSessionReplayRecording();
